'use client';
import dynamic from 'next/dynamic';
import type React from 'react';
import { Component, ReactNode } from 'react';

import ProgressBarAnimation from '@cineamo/ui/src/loading/ProgressBarAnimation';
import type { SeatMap3DProps } from '@cineamo/ui/src/seat-map-3d/SeatMap3D.types';
import { handleRenderError, markWebGLUnavailable } from '@cineamo/ui/src/seat-map-3d/webgl-support';

const SeatMap3D = dynamic(() => import('@cineamo/ui/src/seat-map-3d/SeatMap3D'), {
    ssr: false,
    loading: () => (
        <div className="min-h-[50vh] flex items-center justify-center">
            <ProgressBarAnimation className="w-[200px] h-[24px]" />
        </div>
    )
});

class SeatMap3DErrorBoundary extends Component<{ onError: () => void; children: ReactNode }, { hasError: boolean }> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: unknown) {
        handleRenderError(error);
        this.props.onError();
    }

    render() {
        return this.state.hasError ? null : this.props.children;
    }
}

export default function SeatMap3DLazy(props: SeatMap3DProps): React.JSX.Element {
    const onUnavailable = () => {
        markWebGLUnavailable();
        props.onUnavailable?.();
    };
    return (
        <SeatMap3DErrorBoundary onError={() => props.onUnavailable?.()}>
            <SeatMap3D
                {...props}
                onUnavailable={onUnavailable}
            />
        </SeatMap3DErrorBoundary>
    );
}
